import { Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { GeneralService } from 'src/app/service/general-service';

@Component({
  selector: 'app-show-history',
  templateUrl: './show-history.component.html',
  styleUrls: ['./show-history.component.scss']
})
export class ShowHistoryComponent implements OnChanges {
  @Input() visibleValidHistory: boolean;
  @Input() orderCode: any;
  @Output() closeModal = new EventEmitter();

  formFilter = {
    page: 1,
    pageSize: 10000,
    fromDate: "",
    toDate: "",
    sid: ""
  }
  datas: any;
  constructor(
    private generalService: GeneralService
  ) { }

  ngOnChanges(): void {
    this.formFilter.sid = this.orderCode;
    this.getListData();
  }

  closeModalLog() {
    this.visibleValidHistory = false;
    this.closeModal.emit(false);
  }

  getListData() {
    this.generalService.showValidHistory(this.formFilter).subscribe((res) => {
      if(res.data) {
        this.datas = res.data;
      }
    })
  }

  doSearch() {
    this.formFilter.sid = this.orderCode;
    this.getListData();
  }
}
